import React, { useEffect } from "react";
import { message, Modal } from "antd";
import { toReadableText } from "../../utils/common";

export default function NotificationManager() {
  const [messageApi, messageContext] = message.useMessage();
  const [modalApi, modalContext] = Modal.useModal();

  useEffect(() => {
    const buildHandler = (type, defaultTitle) => {
      return (content, optOrDuration) => {
        const isNumber = typeof optOrDuration === "number";

        const options = isNumber ? {} : optOrDuration || {};
        const duration = isNumber ? optOrDuration : options.duration;
        const modal = options.modal ?? false;

        const isRenderable =
          React.isValidElement(content) || Array.isArray(content);

        const text = isRenderable
          ? content
          : typeof content === "string"
            ? content
            : toReadableText(content);

        // --- MENSAJE NORMAL ---
        if (!modal) {
          if (isRenderable) {
            messageApi.open({
              type,
              content: text,
              duration
            });
          } else {
            messageApi[type](text, duration);
          }
          return;
        }

        // --- MODAL ---
        const modalInstance = modalApi[type]({
          title: options.title || defaultTitle,
          content: text,
          centered: true,
          ...options, // permite width, footer, etc.
        });

        // Duration para cerrar modal automáticamente
        if (duration && typeof duration === "number") {
          setTimeout(() => {
            modalInstance.destroy?.();
          }, duration * 1000);
        }
      };
    };

    window.messageApi = {
      success: buildHandler("success", "Éxito"),
      error: buildHandler("error", "Error"),
      info: buildHandler("info", "Información"),
      warning: buildHandler("warning", "Advertencia"),
      confirm(options) {
        return modalApi.confirm({
          centered: true,
          ...options,
        });
      },

      loading(content, duration) {
        messageApi.loading(content, duration);
      },

      destroy() {
        messageApi.destroy();
      }
    };
  }, [messageApi, modalApi]);

  return (
    <>
      {messageContext}
      {modalContext}
    </>
  );
}